import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.667 6.875V15c0 2.5-1.492 3.333-3.334 3.333H6.668c-1.842 0-3.333-.833-3.333-3.333V6.875c0-2.708 1.491-3.333 3.333-3.333 0 .516.208.983.55 1.325.341.341.808.55 1.325.55h2.917a1.88 1.88 0 0 0 1.875-1.875c1.841 0 3.333.625 3.333 3.333"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.333 3.542a1.88 1.88 0 0 1-1.875 1.875H8.541c-.516 0-.983-.209-1.325-.55a1.86 1.86 0 0 1-.55-1.325c0-1.034.842-1.875 1.875-1.875h2.917c.517 0 .983.208 1.325.55.342.341.55.808.55 1.325M6.667 10.833H10M6.667 14.167h6.666"
    }, null, -1)
  ]))]))
}
export default { render: render }